module.exports = __webpack_public_path__ + "media/images/friendbuy-0ec562fa2041eed0e372d6146879c413.svg";